import React, { useEffect, useRef } from 'react';
import { TopBar } from './navbar/TopBar';
import { Logo } from './navbar/Logo';
import { DesktopMenu } from './navbar/DesktopMenu';
import { ContactButton } from './navbar/ContactButton';
import { MobileMenu } from './navbar/MobileMenu';
export function Navbar() {
  const navRef = useRef<HTMLDivElement>(null);
  return <nav className="fixed top-0 left-0 right-0 z-50" ref={navRef} data-id="element-75">
      <TopBar data-id="element-76" />

      <div className="bg-brand-black/95 backdrop-blur-md border-b border-brand-gray-800 relative" data-id="element-77">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-78">
          <div className="flex items-center h-20" data-id="element-79">
            <Logo data-id="element-80" />
            <DesktopMenu data-id="element-81" />
            <ContactButton data-id="element-82" />
            <MobileMenu data-id="element-83" />
          </div>
        </div>
      </div>
    </nav>;
}